import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      {/* Footer Top */}
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* About Section */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-footer">
                <h2>About Us</h2>
                <p>Financial Pros Online</p>
        
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-footer f-link">
                <h2>Quick Links</h2>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12">
                    <ul>
                      <li>
                        <a href="/" onClick={() => window.location.reload()}><i className="fa fa-caret-right" aria-hidden="true"></i>Home</a>
                      </li>
                      <li>
                        <Link to="/about"><i className="fa fa-caret-right" aria-hidden="true"></i>About Us</Link>
                      </li>
                      <li>
                        <Link to="/contact"><i className="fa fa-caret-right" aria-hidden="true"></i>Contact Us</Link>
                      </li>
               
                    </ul>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <ul>
                    
                      <li>
                        <Link to="/testimonials"><i className="fa fa-caret-right" aria-hidden="true"></i>Testimonials</Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy"><i className="fa fa-caret-right" aria-hidden="true"></i>Privacy Policy</Link>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Open Hours */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-footer">
                <h2>Open Hours</h2>
                <ul className="time-sidual">
                  <li className="day">
                    Monday - Friday <span>7:00-10:00</span>
                  </li>
                  <li className="day">
                    Saturday - Sunday <span>12:00-6:00</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="single-footer">
                <h2>Newsletter</h2>
                <p>Subscribe to our newsletter to get new updates</p>
                <form action="#" method="get" target="_blank" className="newsletter-inner">
                  <input
                    name="email"
                    placeholder="Email Address"
                    className="common-input"
                    onFocus={(e) => (e.target.placeholder = '')}
                    onBlur={(e) => (e.target.placeholder = 'info@financialprosonline.com')}
                    required
                    type="email"
                  />
                  <button className="button" type="submit">
                    <i className="icofont icofont-paper-plane"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Footer Top */}

      {/* Copyright */}
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="copyright-content">
                <p>
                  © Copyright 2024 | All Rights Reserved by{' '}
                  <a href="https://financialprosonline.com" target="_blank" rel="noopener noreferrer">Financial Pros Online</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Copyright */}
    </footer>
  );
};

export default Footer;
